export default __webpack_public_path__ + "static/media/camp-boy.5ca613e0.png";